import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Input, message, Upload, Tooltip } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { EditableRow, EditableCell } from '@/components/YHEditTable/editTable'
import useGlobalModel, { transOptions, getFindItem } from '@/model/globalModel'
import { formatInt, formatNum, formatDiscount, bigNumber } from '@/utils/utils'
import { YhAuth } from '@/components/auth/YhAuth'
import { ISCMPDrGoodsDetail } from '../../purchaseDrTypes'
import { usePurchaseDrDetailsModel } from './purchaseDrDetailsModel'
import { importPropsConfigScm, messageConfig } from '@/utils/importFile'
import { ResourceAuthEnum } from '@/types/VrmResoureAuthEnum'
import { ISelectOption } from '@/components/YhFormBox/Types'
import { warehouseService } from '@/views/base/warehouse/warehouseService'
import { IVRMshelfDetail } from '@/views/base/warehouse/warehouseTypes'
import { IDetailList } from '@/views/sale/order/saleOrderTypes'
import { HistoryModel } from '@/views/historyModel'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { BatchSelectWarehouseModal } from './BatchSelectWarehouseModal'
import { roleColumnModel } from "@/utils/roleColumn";
import YhTootip from "@/components/YhTootip";

type ISCMPDrGoodsSearch = {
    data: ISCMPDrGoodsDetail[]
    isSearch: boolean
}

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        shopAndOrg: { shopId },
        setLoadingInfo,
        warehouseList,
    } = useGlobalModel()
    const {
        addGoodsList,
        editFormVal,
        addFormVal,
        addOutShopCode,
        setAddGoodsList,
        editGoodsList,
        setEditGoodsList,
        setAddGoodsModal,
        pDrDownload,
        exportPDrdetail,
        setHistoryVisible,
        historyRow,
        historyVisible,
        setHistoryRow,
        setAddTempShelfModal,
        setSaveBtn,
        setButtonControl,
    } = usePurchaseDrDetailsModel()
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    //批量选择仓库
    const [batchSelectWarehouseModal, setBatchSelectWarehouseModal] = useState<boolean>(false)
    const [batchSelectWarehouseList, setBatchSelectWarehouseList] = useState<ISCMPDrGoodsDetail[]>([])

    const onHistoryModel = (record: ISCMPDrGoodsDetail) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])
    const [searchParms, setSearchParms] = useState<string>('')
    const [searchVal, setSearchVal] = useState<ISCMPDrGoodsSearch>({ data: [], isSearch: false }) //用于搜索展示的数据
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<IVRMshelfDetail[]>([])
    //删除商品
    const onRemove = () => {
        if (!selectedRowKeys.length) {
            message.warning('请选择你要删除的商品')
            return
        }
        mode === 'edit'
            ? setEditGoodsList((origin) => origin.filter((item) => selectedRowKeys.indexOf(item.key) < 0))
            : setAddGoodsList((origin) => origin.filter((item) => selectedRowKeys.indexOf(item.key) < 0))

        let newSearchData = searchVal.data.filter((item) => selectedRowKeys.indexOf(item.key) < 0)
        setSearchVal({ data: newSearchData, isSearch: searchVal.isSearch })

        setSelectedRowKeys([])
        message.success('删除成功')
    }

    //搜索  前端自己保存搜索的值， 搜索值为空还是用缓存
    const goodsFilter = (dataSource: ISCMPDrGoodsDetail[] | null = null) => {
        const isEtit = mode === 'edit'
        let goodsList = dataSource ? dataSource : [...(isEtit ? editGoodsList : addGoodsList)]
        if (searchParms) {
            let reg = new RegExp(searchParms)
            let arr: ISCMPDrGoodsDetail[] = []
            goodsList.forEach((item) => {
                if (item.materialCode?.match(reg) || item.materialName?.match(reg)) {
                    arr.push(item)
                }
            })
            setSearchVal({ data: arr, isSearch: true })

            if (!arr.length) {
                message.warning('列表没有该商品！！')
            }
        } else {
            setSearchVal({ data: [], isSearch: false })
        }
    }

    //多选仓库
    const toChooseWs = () => {
        let dataSource = mode === 'edit' ? editGoodsList : addGoodsList
        // dataSource = dataSource.filter((i) => selectedRowKeys.includes(i.id))
        // let isCheck = true
        // dataSource.every((item, index) => {
        //     isCheck = !item.inWarehouseCode
        //     !isCheck && message.error(`${item.materialName}有仓库，不能批量设置`)
        //     return isCheck
        // })
        // if (!isCheck) return
        let newData = dataSource.filter((item, index) => !item.inWarehouseCode)
        if (newData.length > 0) {
            setBatchSelectWarehouseList(dataSource)
            setBatchSelectWarehouseModal(true)
        } else {
            message.error(`所有配件都已分配调入仓库，不能批量设置`)
        }
    }

    //导入明细成功
    const upLoadCallback = (list: any[]) => {
        setButtonControl(true)
        if (!list?.length) return message.warning('请导入正确格式的配件')
        const isEdit: boolean = mode === 'edit'
        const goodsList: ISCMPDrGoodsDetail[] = [...(isEdit ? editGoodsList : addGoodsList)]
        let newShelfRows: any[] = []
        let str: string = ''
        list.forEach((item) => {
            let num: number = item.num ?? 0
            let price: number = item.price
            if (!item.success) {
                str += `【${item.msg}】`
            }
            if (item.inventoryDetailsList && item.inventoryDetailsList.length) {
                let data = item.inventoryDetailsList.map((item: any) => {
                    return {
                        ...item,
                        createTime: Number(item.createTime.join('')),
                    }
                })
                const tempArr = data.sort((a: any, b: any) => a.createTime - b.createTime)
                for (let i = 0; i < tempArr.length; i++) {
                    let goods = tempArr[i]
                    // 公共字段
                    let publicData = {
                        id: '',
                        key: goods.id,
                        purchaseDetailsId: goods.id,
                        materialCode: goods.materialCode,
                        materialName: goods.materialName, //商品名称
                        price: bigNumber.times(price, (1 - Number(item.discountRate ?? 0))).toFixed(2),
                        prePrice: price,
                        costPrice: goods.costPrice,
                        purchaseCode: goods.bussCode,
                        inventoryNum: goods.inventoryQuantity - goods.occupyNum,
                        typeName: goods.typeName,
                        typeCode: goods.typeCode,
                        outWarehouseCode: goods.warehouseCode, //仓库编码
                        outWarehouseName: goods.warehouseName, //仓库编码
                        outShelfCode: goods.shelfCode,
                        replaceCode: goods.replaceCode,
                        unitName: goods.unitName,
                        unitCode: goods.unitCode,
                        latestPurPrice: goods.latestPurPrice,
                        discountRate: item.discountRate
                    }
                    // 可用库存 = 库存数量 - 占用库存
                    let kynum = goods.inventoryQuantity - goods.occupyNum
                    //当匹配到最后一个配件, 可用库存不满足用户填写数量, 那就设置该配件为异常配件, 数量设置为减完前面配件可用库存剩余的数量
                    if (i === tempArr.length - 1 && kynum < num) {
                        newShelfRows.push({
                            ...publicData,
                            isHave: true,
                            error: item.msg,
                            num, //开单数量
                            confirmNum: num ?? 1,
                            preAmount: +bigNumber.toFixed(bigNumber.times(Number(price ?? 0), Number(num ?? 1)), 2),
                            //总计=单价*（1-下浮）*（单品开单数量-单品赠品数量）-单品优惠
                            // amount: +formatNum(Number(price ?? 0) * (1 - Number(item.discountRate ?? 0)) * Number(num ?? 1)),
                            amount: +bigNumber.times(bigNumber.times(price, (1 - item.discountRate)).toFixed(2), num).toFixed(2)

                        })
                        break
                    }
                    if (num <= 0) break
                    if (kynum) {
                        num = num - kynum
                        // 当 可用数量 小于
                        let tempNum = num < 0 ? kynum + num : kynum
                        newShelfRows.push({
                            ...publicData,
                            isHave: item.success,
                            msg: item.msg,
                            num: tempNum, //开单数量
                            confirmNum: tempNum ?? 1,
                            preAmount: +bigNumber.toFixed(bigNumber.times(Number(price ?? 0), Number(tempNum ?? 1)), 2),
                            //总计=单价*（1-下浮）*（单品开单数量-单品赠品数量）-单品优惠
                            // amount: +formatNum(Number(price ?? 0) * (1 - Number(item.discountRate ?? 0)) * Number(tempNum ?? 1)),
                            amount: +bigNumber.times(bigNumber.times(price, (1 - item.discountRate)).toFixed(2), tempNum).toFixed(2)

                        })
                    }
                }
            }
        })
        isEdit ? setEditGoodsList((origin) => [...origin, ...newShelfRows]) : setAddGoodsList((origin) => [...origin, ...newShelfRows])
        setLoadingInfo({ loadingVisible: false, txt: '' })
        messageConfig(str ? str : '导入成功', 20, 'info')
    }
    const { branchOut, outShopId, branchIn } = mode === 'edit' ? editFormVal : addFormVal
    const importUrl = `/zzw-vrm/stock/details/allocationImport/${outShopId}/${shopId}/${branchIn}`
    // branchOut === "vrm"
    //     ? `/zzw-vrm/stock/details/allocationImport/${outShopId}/${shopId}/${branchIn}`
    //     : branchOut === 'scm'
    //         ? `/scm2/sale/so/allocationImport/${outShopId}/${shopId}/${branchIn}`
    //         : `/bcm/stock/details/allocationImport/${outShopId}/${shopId}/${branchIn}`
    const action = (
        <div className="flex justify-between white-space">
            <div>
                {mode !== 'edit' && (
                    <>
                        <YhAuth resCode={ResourceAuthEnum.P_DR_AD_ADD_M}>
                            <Button
                                className="mr-5"
                                type="primary"
                                shape="round"
                                onClick={() => {
                                    setAddGoodsModal(true)
                                }}
                            >
                                新增商品
                            </Button>
                        </YhAuth>
                        <YhAuth resCode={ResourceAuthEnum.P_DR_AD_DEL_M}>
                            <Button className="mr-5" type="primary" shape="round" onClick={() => onRemove()}>
                                删除商品
                            </Button>
                        </YhAuth>
                        <YhAuth resCode={ResourceAuthEnum.P_DR_AD_DLOAD}>
                            <Button
                                className="mr-5"
                                type="primary"
                                shape="round"
                                onClick={() => {
                                    pDrDownload()
                                }}
                            >
                                下载模板
                            </Button>
                        </YhAuth>
                    </>
                )}

                <YhAuth resCode={ResourceAuthEnum.P_DR_AD_IM}>
                    <Upload
                        showUploadList={false}
                        className="mr-10 ml-10"
                        {...importPropsConfigScm(importUrl, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: '快速导入中' }))}
                    >
                        <Button disabled={mode == 'edit' ? !editFormVal.branchOut : !addFormVal.branchOut} className="mr-5" type="primary" shape="round">
                            导入
                        </Button>
                    </Upload>
                </YhAuth>
                {mode === 'edit' && (
                    <YhAuth resCode={ResourceAuthEnum.P_DR_TEMP_SHELF}>
                        {/* <Button
                                className="mr-5"
                                type="primary"
                                shape="round"
                                onClick={() => {
                                    let filterGoodsShelf = editGoodsList.filter(item => !!!item.inShelfCode);
                                    setAddTempShelfModal(true)
                                }}
                            >
                                添加临时货位
                        </Button> */}
                        <Button className="mr-5" type="primary" shape="round" onClick={toChooseWs}>
                            选择仓库
                        </Button>
                    </YhAuth>
                )}
                {/* {mode === "edit" && <YhAuth resCode={ResourceAuthEnum.P_DR_ED_EX}><Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { exportPDrdetail() }}
            >导出</Button></YhAuth>} */}
            </div>
            <div className="flex">
                <Input
                    allowClear
                    datatype="round"
                    className="border-r-16"
                    placeholder="商品编号/商品名称"
                    onChange={(e) => setSearchParms(e.target.value)}
                    onBlur={(e) => setSearchParms(e.target.value?.trim())}
                    onPressEnter={() => goodsFilter()}
                />
                <Button style={{ margin: '0px 12px 0px 15px' }} shape="round" onClick={() => goodsFilter()}>
                    {' '}
                    检索
                </Button>
            </div>
        </div>
    )
    const wsChanges = async (value: string, option: ISelectOption, record: ISCMPDrGoodsDetail) => {
        // let params = {
        //     pageSize: 10000,
        //     pageNum: 1,
        //     warehouseCode: value,
        // }
        // const { retData } = await warehouseService.shelfAllPage(params)
        // const newRecords = retData.map((item: IVRMshelfDetail) => {
        //     return { ...item, name: item.code }
        // })
        // setShelfAllList(newRecords)
        let params = {
            shopId,
            warehouseCode: value,
            materialCode: record.materialCode as string,
        }
        const {
            retData: { shelfId, shelfCode },
        } = await warehouseService.getMaterialShelfTemporary(params)
        let dataSource = mode === 'edit' ? editGoodsList : addGoodsList
        const index = dataSource.findIndex((item) => record.key === item.key)
        const item = dataSource[index]
        if (shelfCode && shelfId) {
            dataSource.splice(index, 1, { ...item, inShelfCode: shelfCode, inShelfId: shelfId })
        } else {
            dataSource.splice(index, 1, { ...item, inShelfCode: '', inShelfId: '', inWarehouseCode: '', inWarehouseName: '' })
            message.error('该仓库下没有临时货位')
        }
        mode === 'edit' ? setEditGoodsList([...dataSource]) : setAddGoodsList([...dataSource])
    }

    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: 'center',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '提示',
            width: 60,
            fixed: 'left',
            align: 'center',
            dataIndex: '',
            render: (t: any, r: any) =>
                !r.isHave || r?.error ? (
                    <Tooltip
                        placement="topLeft"
                        title={!r.isHave ? r?.msg ?? '调入站点没有该商品, 保存时将自动添加该商品, 请及时维护对应的商品信息' : r.error}
                        arrowPointAtCenter
                    >
                        <ExclamationCircleOutlined style={{ color: '#FF4500', fontSize: '20px' }} />
                    </Tooltip>
                ) : (
                    ''
                ),
        },
        {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            fixed: 'left',
            render: (text: any, record: any, index: number) => (
                <Tooltip placement="topLeft" title={text}>
                    <p
                        className="ellipsis click-span"
                        onClick={(e) => {
                            e.stopPropagation()
                            onHistoryModel(record)
                        }}
                    >
                        {text}
                    </p>
                </Tooltip>
            ),
            sorter: {
                compare: (a: { materialCode: string }, b: { materialCode: string }) => a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0),
                multiple: 1,
            },
        },
        {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: 'left',
            sorter: {
                compare: (a: any, b: any) => a.materialName.localeCompare(b.materialName, 'zh-Hans-CN', { sensitivity: 'accent' }),
                multiple: 2,
            },
        }, {
            title: '商品大类',
            width: 120,
            dataIndex: 'pTypeName',
            render: (text: any, res: any) => text ?? res.typeName
        }, {
            title: '商品小类',
            width: 120,
            dataIndex: 'typeName',
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '适用车型',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '品牌',
            width: 100,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        },
        {
            title: '调拨数量',
            width: 100,
            dataIndex: 'num',
            editable: mode === 'add',
        }, {
            title: '折前单价',
            width: 120,
            dataIndex: 'prePrice',
            editable: mode === "add",
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '折前调拨金额',
            width: 120,
            dataIndex: 'preAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '下浮',
            width: 100,
            dataIndex: 'discountRate',
            // editable: mode === "add" || status === DictCodeEnmu.TRANSFER_STATUS_INIT,
        },
        {
            title: '单价',
            width: 130,
            dataIndex: 'price',
            // editable: mode === 'add',
            render: (text: any) => `￥${formatNum(text)}`,
        },
        {
            //     title: '下浮',
            //     width: 100,
            //     dataIndex: 'discountRate',
            //     editable: mode === "add",
            // }, {
            title: '调拨金额',
            width: 136,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text)}`,
        },
        {
            title: '成本单价',
            width: 136,
            dataIndex: 'costPrice',
            render: (text: any) => `￥${formatNum(text ?? 0)}`,
        },
        {
            title: '调入仓库',
            width: 120,
            dataIndex: 'inWarehouseCode',
            // editable:true,
            editable: editFormVal.status === 'transfer-status.in' && mode === 'edit' ? false : true,
            editType: 'select',
            onSelectChange: wsChanges,
            options: transOptions(warehouseList),
            rules: [{ required: true, message: '请选择仓库' }],
            render: (text: string) => transOptions(warehouseList).find((item) => item.value === text)?.label ?? '请选择仓库',
        },
        {
            title: '调入货位',
            width: 120,
            dataIndex: 'inShelfCode',
            // editable:true,
            // editable: editFormVal.status === 'transfer-status.in' && mode === 'edit' ? false : true,
            editable: false,
            // editType: 'select',
            // rules: [{ required: true, message: '请选择货位' }],
            // options: transOptions(shelfAllList),
            // render: (text: string) => text ?? '请选择货位',
        },
        {
            title: '调出仓库',
            width: 120,
            dataIndex: 'outWarehouseName',
        },
        {
            title: '调出货位',
            width: 120,
            dataIndex: 'outShelfCode',
        },
        {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        },
    ]

    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: any, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseIn", "roleCodes": roles };
        return getRoleColumns("purchaseIn", "明细", newSelectColumns(), params);
    }, [roles, editGoodsList, addGoodsList, defaultColumns]);
    //内联编辑   (计算价格)
    const handleSave = (row: ISCMPDrGoodsDetail) => {
        row.num = +formatInt(row.num, +(row?.inventoryNum ?? 0), '调拨数量>=库存')
        row.price = +bigNumber.times(row.prePrice, (1 - (+row.discountRate))).toFixed(2);
        row.prePrice = +formatNum(row.prePrice);
        row.preAmount = +bigNumber.times(row.prePrice, row.num).toFixed(2);
        if (mode === 'add' && row.prePrice < +formatNum(row.costPrice)) {
            row.prePrice = +formatNum(row.costPrice)
            message.warning('您填写的单价不能小于进货价,已为您重置为进货价')
        }
        row.discountRate = +formatDiscount(row.discountRate)
        row.inWarehouseName = getFindItem(row.inWarehouseCode as string, warehouseList)?.name
        row.inShelfId = getFindItem(row.inShelfCode as string, shelfAllList)?.id ?? row.shelfId
        // //总计=单价*（1-下浮）*开单数量
        row.amount = +bigNumber.toFixed(bigNumber.times(bigNumber.times(row.prePrice, bigNumber.minus(1, row.discountRate)), row.num), 2)
        let dataSource = mode === 'edit' ? editGoodsList : addGoodsList
        const index = dataSource.findIndex((item) => row.key === item.key)
        const item = dataSource[index]
        dataSource.splice(index, 1, { ...item, ...row })
        mode === 'edit' ? setEditGoodsList([...dataSource]) : setAddGoodsList([...dataSource])

        // setWsConfirmDisable(true);
        // //判断仓库变化时，  重置货位
        if (row.inWarehouseCode !== dataSource[index].inWarehouseCode) {
            row.inShelfCode = undefined
        }
        //判断展示的是搜索后的数据，然后搜索的也改变
        if (searchVal.isSearch) {
            goodsFilter(dataSource)
        }
        setButtonControl(true)
        setSaveBtn(true)
    }

    return (
        <YhBox title="" action={action} style={{ marginBottom: '75px' }}>
            <Table
                bordered
                rowKey={(record) => record.key}
                rowClassName={(record) => {
                    if (!record?.isHave || record?.error) return 'editable-row yh-edit-table-tr background-FFB4B4'
                    return 'editable-row yh-edit-table-tr'
                }}
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMPDrGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[])
                    },
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={roleColumns}
                dataSource={searchVal.isSearch ? searchVal.data : mode === 'edit' ? editGoodsList : addGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow.materialCode as string}
                materialName={historyRow.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />

            <BatchSelectWarehouseModal
                mode={mode}
                batchSelectWarehouseModal={batchSelectWarehouseModal}
                setBatchSelectWarehouseModal={setBatchSelectWarehouseModal}
                batchSelectWarehouseList={batchSelectWarehouseList}
                selectedRowKeys={selectedRowKeys}
            />
        </YhBox>
    )
}
